import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { MlosLeadTimeRuleValidation } from 'uplisting-frontend/validations';

export default class MlosLeadTimeRuleRepositoryService extends BaseRepositoryService<
  ModelRegistry['mlos-lead-time-rule']
> {
  recordName = 'mlos-lead-time-rule';
  implementMethods = [
    'buildChangeset',
    'createRecord',
    'peekAll',
    'query',
    'destroyRecord',
  ];

  validation = MlosLeadTimeRuleValidation;

  buildNewRule(
    property: ModelRegistry['property'],
  ): ModelRegistry['mlos-lead-time-rule'] {
    return this.createRecord({ enabled: true, property });
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/mlos-lead-time-rule': MlosLeadTimeRuleRepositoryService;
  }
}
